import React, {useState, useEffect, createRef} from 'react';
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../components/TableIcons';
import {httpPaginationPost} from './../../../util/Rest';
import {useDispatch} from 'react-redux';
import GuiTable from '../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../constants/ReusableConstants';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {
  fetchLookupDetails,
  resetLookDetails,
} from '../../../redux/reducers/LookupMaintenance/AddLookup';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';
import ViewLookUptable from './ViewLookUptable';
import DialogBox from '../../../components/DialogBox';

export default function LookupMaintenanceTable({
  searchData,
  setSubmit,
  submit,
  setValue,
  setRowData,
  LookupMaintenanceAccess,
}) {
  const [arrayLast, setArrayLast] = useState(false);
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const dispatch = useDispatch();
  const [ViewOpen, setViewOpen] = useState(false);
  const [tableData, setTableData] = useState('');
  const ViewDialogClose = () => {
    setViewOpen(false);
    dispatch(resetLookDetails());
  };
  const columns = [
    {
      title: 'Look Table Code',
      field: 'typeCode',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  useEffect(() => {
    dispatch(resetLookDetails());
  }, []);
  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table global-field-table new-standard-textfields custom-toolbar-icons custom-actions-icon">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `lookup/searchall/lookuptypedetails`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  typeCode: searchData?.lookupCode ? searchData?.lookupCode : '',
                  description: searchData?.description ? searchData?.description : '',
                  search: query?.search ? query?.search : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };

                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;

                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              toolbar: false,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => <EditOutlinedIcon />,
                tooltip: 'Edit',
                disabled: !LookupMaintenanceAccess?.edit,
                onClick: (event, rowData) => {
                  dispatch(fetchLookupDetails(rowData?.typeCode));
                  setRowData(rowData);
                  setValue(1);
                },
              },
              {
                icon: () => <VisibilityOutlinedIcon />,
                tooltip: 'View',
                onClick: (event, rowData) => {
                  dispatch(fetchLookupDetails(rowData?.typeCode));
                  setTableData(rowData);
                  setViewOpen(true);
                },
              },
            ]}
          />
        </div>
        <DialogBox
          open={ViewOpen}
          dialogClose={ViewDialogClose}
          title={`${tableData?.typeCode}`}
          maxWidth="md"
        >
          <ViewLookUptable />
        </DialogBox>
      </Grid>
    </>
  );
}
